import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import SplitType from 'split-type';
import { debounce } from '../modules/utils';

gsap.registerPlugin(ScrollTrigger);

export const textReveal = (triggerEl, headingEl, introEl, buttonEl, delay, splitType) => {
  let splitHeading;
  let splitIntro;
  let tl = gsap.timeline({
    scrollTrigger:
      triggerEl !== undefined
        ? {
            trigger: triggerEl,
            start: 'top 90%',
            scrub: false,
            toggleActions: 'play none none reverse',
          }
        : null,
  });

  if (headingEl !== undefined) {
    splitHeading = new SplitType(headingEl, { types: 'lines, words' });
    tl.fromTo(
      splitType == 'by-lines' ? splitHeading.lines : splitHeading.words,
      {
        y: 30,
        opacity: 0,
      },
      {
        y: 0,
        opacity: 1,
        stagger: 0.1,
        ease: 'circ.out',
        delay: delay ? delay : 0,
      },
    );
  }

  if (introEl !== undefined) {
    splitIntro = new SplitType(introEl, { types: 'lines' });

    tl.from(
      splitIntro.lines,
      {
        y: 20,
        duration: 0.5,
        stagger: 0.1,
        opacity: 0,
        ease: 'circ.out',
      },
      '-=0.2',
    );
  }

  if (buttonEl !== undefined) {
    tl.from(
      buttonEl,
      {
        y: 20,
        opacity: 0,
        duration: 0.4,
      },
      '-=0.2',
    );
  }

  window.addEventListener(
    'resize',
    debounce(function () {
      if (splitHeading) splitHeading.split();
      if (splitIntro) splitIntro.split();
      ScrollTrigger.refresh();
    }, 250),
  );
};
